import { Phone } from "lucide-react";
import { useI18n } from "@/i18n";
import { trackPhoneClick } from "@/lib/analytics";

/**
 * Fixed top utility bar with a big tap-to-call phone CTA.
 * Always visible above the navbar. Height ~52px.
 * Fires GA4 "phone_click" and Meta "Contact" events on click.
 */
export default function TopPhoneBar() {
  const { t } = useI18n();
  const handleClick = () => trackPhoneClick("top_bar");
  return (
    <a
      href="tel:+33182001867"
      onClick={handleClick}
      data-testid="top-phone-bar"
      className="fixed top-0 left-0 right-0 z-[60] block w-full bg-[#203240] text-white hover:bg-[#34495E] transition-colors"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16 py-3 flex items-center justify-center gap-3 text-center">
        <Phone size={18} className="text-[#B8956A] shrink-0" />
        <span className="hidden sm:inline text-xs uppercase tracking-[0.22em] text-white/75">
          {t("topbar.phone")}
        </span>
        <span className="font-display text-xl sm:text-2xl md:text-3xl text-[#B8956A] tracking-wider leading-none">
          01 82 00 18 67
        </span>
      </div>
    </a>
  );
}
